<template>
  <div>
    <b-form-group
      label="Anasayfada"
      label-for="status"
    >
      <b-form-checkbox
        id="status"
        v-model="itemData.is_homepage"
        value="1"
        switch
      >
        {{ itemData.is_homepage === '1'? 'Gösterilsin' : 'Gösterilmesin' }}
      </b-form-checkbox>
    </b-form-group>
  </div>
</template>

<script>
import { BFormGroup, BFormCheckbox } from 'bootstrap-vue'

export default {
  name: 'CorporatePoliciesHomePageStatusCard',
  components: { BFormGroup, BFormCheckbox },
  computed: {
    itemData() {
      return this.$store.getters['corporatePolicies/dataItem']
    },
  },
}
</script>
